document.addEventListener('DOMContentLoaded', () => {
  const upsellProductItems = document.querySelector('.upsell-product-items');
  if (upsellProductItems) {
    const productItems = upsellProductItems.querySelectorAll('.product-item');
    if (productItems.length === 0) {
      upsellProductItems.classList.add('d-none');
      document.querySelector('.upsell-heading')?.classList.add('d-none');
    }
  }
});

const getUpsellProducts = () => {
  const upsellProductItems = document.querySelector('.upsell-product-items');
  if (upsellProductItems) {
    const productItems = upsellProductItems.querySelectorAll('.product-item');
    const checkbox = upsellProductItems.querySelector('input[type="checkbox"]');
    const data = [];
    if (checkbox.checked) {
      for (const productItem of productItems) {
        data.push({ id: parseInt(productItem.getAttribute('product')), quantity: parseInt(productItem.getAttribute('quantity')) });
      }
    }
    return data;
  }
  return [];
}